export enum SPLOOT_BADGE_COLOR {
  BLUE = "blue",
  PURPLE = "purple",
  GREEN = "green",
  RED = "red",
  YELLOW = "yellow",
  NEUTRAL = "neutral",
  GRAY = "gray",
  ORANGE = "orange",
  LIGHT_GRAY = "lightGray",
}

export enum SPLOOT_BADGE_SIZE {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export type ColorTheme = {
  bg: string;
  text: string;
  border: string;
  hover: string;
};

export const COLOR_THEMES: Record<SPLOOT_BADGE_COLOR, { secondary: ColorTheme; default: ColorTheme }> = {
  [SPLOOT_BADGE_COLOR.BLUE]: {
    secondary: {
      bg: "bg-blue-50",
      text: "text-blue-700",
      border: "border-blue-50",
      hover: "hover:bg-blue-100",
    },
    default: {
      bg: "bg-blue-500",
      text: "text-blue-50",
      border: "border-blue-500",
      hover: "hover:bg-blue-600",
    },
  },
  [SPLOOT_BADGE_COLOR.PURPLE]: {
    secondary: {
      bg: "bg-purple-50",
      text: "text-purple-700",
      border: "border-purple-50",
      hover: "hover:bg-purple-100",
    },
    default: {
      bg: "bg-purple-500",
      text: "text-purple-50",
      border: "border-purple-500",
      hover: "hover:bg-purple-600",
    },
  },
  [SPLOOT_BADGE_COLOR.GREEN]: {
    secondary: {
      bg: "bg-green-50",
      text: "text-green-700",
      border: "border-green-50",
      hover: "hover:bg-green-100",
    },
    default: {
      bg: "bg-green-500",
      text: "text-green-50",
      border: "border-green-500",
      hover: "hover:bg-green-600",
    },
  },
  [SPLOOT_BADGE_COLOR.RED]: {
    secondary: {
      bg: "bg-red-50",
      text: "text-red-700",
      border: "border-red-50",
      hover: "hover:bg-red-100",
    },
    default: {
      bg: "bg-red-500",
      text: "text-red-50",
      border: "border-red-500",
      hover: "hover:bg-red-600",
    },
  },
  [SPLOOT_BADGE_COLOR.YELLOW]: {
    secondary: {
      bg: "bg-yellow-50",
      text: "text-yellow-700",
      border: "border-yellow-50",
      hover: "hover:bg-yellow-100",
    },
    default: {
      bg: "bg-yellow-500",
      text: "text-yellow-50",
      border: "border-yellow-500",
      hover: "hover:bg-yellow-600",
    },
  },
  [SPLOOT_BADGE_COLOR.NEUTRAL]: {
    secondary: {
      bg: "bg-neutral-50",
      text: "text-neutral-700",
      border: "border-neutral-50",
      hover: "hover:bg-neutral-100",
    },
    default: {
      bg: "bg-neutral-500",
      text: "text-neutral-50",
      border: "border-neutral-500",
      hover: "hover:bg-neutral-600",
    },
  },
  [SPLOOT_BADGE_COLOR.GRAY]: {
    secondary: {
      bg: "bg-gray-50",
      text: "text-gray-700",
      border: "border-gray-50",
      hover: "hover:bg-gray-100",
    },
    default: {
      bg: "bg-gray-500",
      text: "text-gray-50",
      border: "border-gray-500",
      hover: "hover:bg-gray-600",
    },
  },
  [SPLOOT_BADGE_COLOR.ORANGE]: {
    secondary: {
      bg: "bg-orange-50",
      text: "text-orange-700",
      border: "border-orange-50",
      hover: "hover:bg-orange-100",
    },
    default: {
      bg: "bg-orange-500",
      text: "text-orange-50",
      border: "border-orange-500",
      hover: "hover:bg-orange-600",
    },
  },
  [SPLOOT_BADGE_COLOR.LIGHT_GRAY]: {
    secondary: {
      bg: "bg-neutral-50",
      text: "text-neutral-700",
      border: "border-neutral-50",
      hover: "hover:bg-neutral-50",
    },
    default: {
      bg: "bg-neutral-100",
      text: "text-neutral-700",
      border: "border-neutral-100",
      hover: "hover:bg-neutral-100",
    },
  },
};


export const SOLID_BADGE_THEME = {
  RED: "bg-red-500 text-white border-red-500 hover:bg-red-600",
  GREEN: "bg-green-500 text-white border-green-500 hover:bg-green-600",
  YELLOW: "bg-yellow-500 text-white border-yellow-500 hover:bg-yellow-600",
  BLUE: "bg-blue-500 text-white border-blue-500 hover:bg-blue-600",
  PURPLE: "bg-purple-500 text-white border-purple-500 hover:bg-purple-600",
  NEUTRAL: "bg-neutral-500 text-white border-neutral-500 hover:bg-neutral-600",
  GRAY: "bg-gray-500 text-white border-gray-500 hover:bg-gray-600",
  ORANGE: "bg-orange-500 text-white border-orange-500 hover:bg-orange-600",
}

export const OUTLINE_BADGE_THEME = {
  RED: "bg-red-100 text-red-800 border-red-200 hover:bg-red-200",
  GREEN: "bg-green-100 text-green-800 border-green-200 hover:bg-green-200",
  YELLOW: "bg-yellow-100 text-yellow-800 border-yellow-200 hover:bg-yellow-200",
  BLUE: "bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-200",
  PURPLE: "bg-purple-100 text-purple-800 border-purple-200 hover:bg-purple-200",
  NEUTRAL: "bg-neutral-100 text-neutral-800 border-neutral-200 hover:bg-neutral-200",
  GRAY: "bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200",
  ORANGE: "bg-orange-100 text-orange-800 border-orange-200 hover:bg-orange-200",
}

export const BADGE_COLORS: Record<string, string> = {
  // Partner statuses
  ACTIVE: SOLID_BADGE_THEME.GREEN,
  ONBOARDING: SOLID_BADGE_THEME.YELLOW,
  ON_HOLD: SOLID_BADGE_THEME.ORANGE,
  BLOCKED: SOLID_BADGE_THEME.RED,

  // Partner roles
  Groomer: OUTLINE_BADGE_THEME.PURPLE,
  Walker: OUTLINE_BADGE_THEME.BLUE,

  // Service Category
  GROOMING: OUTLINE_BADGE_THEME.PURPLE,
  WALKING: OUTLINE_BADGE_THEME.BLUE,

  // Partner leave statuses
  APPLIED: SOLID_BADGE_THEME.ORANGE,
  APPROVED: SOLID_BADGE_THEME.GREEN,
  REJECTED: SOLID_BADGE_THEME.RED,

  // Session statuses
  COMPLETED: SOLID_BADGE_THEME.GREEN,
  SCHEDULED: OUTLINE_BADGE_THEME.NEUTRAL,
  CANCELLED: SOLID_BADGE_THEME.RED,
  NO_SHOW: SOLID_BADGE_THEME.RED,
  RESCHEDULED: SOLID_BADGE_THEME.BLUE,

  // Online statuses
  Online: OUTLINE_BADGE_THEME.GREEN,
  Offline: OUTLINE_BADGE_THEME.NEUTRAL,
}